export type MarketplaceRole = "agent" | "lender";

export const DEFAULT_MARKETPLACE_ROLE: MarketplaceRole = "agent";

export function resolveMarketplaceRole(
  searchParams: URLSearchParams,
): MarketplaceRole {
  return searchParams.get("role") === "lender" ? "lender" : "agent";
}

export function isMarketplaceRoleSupported(role: MarketplaceRole): boolean {
  return role === "agent";
}

export function marketplaceBrowseHref(role: MarketplaceRole): string {
  return `/marketplace/browse?role=${role}`;
}

export type MarketplaceShellDestination = "offers" | "marketplace-browse";

/**
 * Derives which marketplace-family sidebar item (if any) a DashboardShell
 * route without an explicit `activeView` prop should highlight (plan 291
 * simplify pass 2). Both branches are explicit path matches — there is no
 * catch-all fallback. A path that matches neither returns `undefined`
 * ("highlight nothing"), rather than the old behavior of defaulting every
 * unmatched path (e.g. `/preview/relationship`, `/preview/marketplace/status-card`)
 * to "offers" and double-highlighting "Your Offers" on pages that aren't
 * the offers surface at all.
 */
export function marketplaceShellDestination(
  pathname: string,
): MarketplaceShellDestination | undefined {
  if (
    pathname.endsWith("/marketplace/browse") ||
    pathname === "/marketplace" ||
    pathname.startsWith("/market/agents/") ||
    pathname.startsWith("/preview/market/agents/")
  ) {
    return "marketplace-browse";
  }
  if (
    pathname === "/offers" ||
    pathname.startsWith("/offers/") ||
    pathname === "/preview/offers" ||
    pathname.startsWith("/preview/offers/")
  ) {
    return "offers";
  }
  return undefined;
}
